import React, { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setCanvas, setDimensions, setMaskSprite, setLoading } from "../../Store/reducers/pixiCanvasSlice.js";
import * as PIXI from "pixi.js";
import PixiBackgrounds from "./pixiBackgrounds.jsx";
import { initDevtools } from "@pixi/devtools";
import DisplacementEffect from "./displacementEffect.jsx";
import image5 from "../../assets/backgroundImages/white.png";
import { setZoom } from "../../Store/reducers/fabriccontrolsSlice.js";
import MainLoader from "../Loaders/MainLoader.jsx";

let BASE_WIDTH = 650;
let BASE_HEIGHT = 500;

const PixiCanvas = () => {
    const canvasRef = useRef(null);
    const parentRef = useRef(null);
    const dispatch = useDispatch();
    const appRef = useRef(null);
    const { svgDetails } = useSelector((state) => state.svgDetails);
    const pixiCanvas = useSelector((state) => state.canvas);
    const loading = useSelector((state) => state.canvas.loading);
    const maskSprite = useSelector((state) => state.canvas.maskSprite);
    const selectedMockup = useSelector((state) => state.mockupCategories.selectedMockup) || [];
    BASE_WIDTH=selectedMockup?.width
    BASE_HEIGHT=selectedMockup?.height
    
    const prevDevicePixelRatio = useRef(window.devicePixelRatio);
    const createPixiApp = () => {
        const app = new PIXI.Application({
            width: selectedMockup.width || BASE_WIDTH,
            height: selectedMockup.height || BASE_HEIGHT,
            backgroundColor: 0x00000000,
            backgroundAlpha: 0,
            antialias: true,
            resolution: window.devicePixelRatio,
            autoDensity: true,
            powerPreference: "high-performance",
            forceCanvas: false,
            preserveDrawingBuffer: true
        });
        appRef.current = app;
        if (canvasRef.current) canvasRef.current.appendChild(app.view);
        initDevtools({ app });
        return app;
    };
  
    const createMaskSprite = (app) => {
        const maskTexture = PIXI.Texture.from(selectedMockup.mask_layer||image5);
        const maskSprite = new PIXI.Sprite(maskTexture);
        maskSprite.isMaskSprite = true;
        maskSprite.anchor.set(0.5);
        app.cameraContainer.addChild(maskSprite);
        return maskSprite;
    };

    const adjustCanvasSize = (maskSprite, resetZoom = true) => {
        const availableWidth = window.innerWidth - 100;
        const availableHeight = window.innerHeight - 150;
        const scaleX = availableWidth / BASE_WIDTH;
        const scaleY = availableHeight / BASE_HEIGHT;
        const baseScale = Math.min(scaleX, scaleY);
        const newWidth = BASE_WIDTH * baseScale;
        const newHeight = BASE_HEIGHT * baseScale;
    
        appRef.current.renderer.resize(newWidth, newHeight);
        dispatch(setDimensions({ width: newWidth, height: newHeight }));
    
        if (resetZoom) {
            dispatch(setZoom(1));
        }
    
        // Resize and reposition mask sprite
        maskSprite.width = newWidth;
        maskSprite.height = newHeight;
        maskSprite.x = newWidth / 2;
        maskSprite.y = newHeight / 2;
    
        appRef.current.cameraContainer.position.set(newWidth / 2, newHeight / 2);
        appRef.current.cameraContainer.pivot.set(newWidth / 2, newHeight / 2);
        appRef.current.cameraContainer.scale.set(1);
    };
    

    useEffect(() => {
        if (appRef.current) return;
    
        const app = createPixiApp();
    
        const cameraContainer = new PIXI.Container();
        app.cameraContainer = cameraContainer;
        app.stage.addChild(cameraContainer);
    
        const maskSprite = createMaskSprite(app);
        dispatch(setCanvas(app));
        dispatch(setMaskSprite(maskSprite));
    
        // Initial resize
        adjustCanvasSize(maskSprite, true);
    
        // Listen to resize events
        const handleResize = () => {
            const currentRatio = window.devicePixelRatio;
    
            if (currentRatio !== prevDevicePixelRatio.current) {
                // devicePixelRatio changed (likely browser zoom)
                prevDevicePixelRatio.current = currentRatio;
                console.log("Zoom changed");
                adjustCanvasSize(maskSprite, false); // don't reset zoom
            } else {
                console.log("Window resized");
                adjustCanvasSize(maskSprite, true); // reset zoom
            }
        };
    
        // window.addEventListener("resize", handleResize);
    
        return () => {
            window.removeEventListener("resize", handleResize);
            app.destroy(true, { children: true });
            appRef.current = null;
        };
    }, [selectedMockup]);
    

    const isLoaded = (pixiCanvas && svgDetails && maskSprite) || !loading;

    return (
        <div className="flex-1 flex justify-center items-start relative" ref={parentRef}>
            <div
                ref={canvasRef}
                className="justify-center items-center"
                style={{ display: isLoaded ? "block" : "none" }}
            >
                <PixiBackgrounds  />
                <DisplacementEffect />
            </div>
            {!isLoaded && (
                <div className="absolute inset-0 flex justify-center items-center">
                    <MainLoader />
                </div>
            )}
        </div>
    );
};

export default PixiCanvas;



// import React, { useEffect, useRef } from "react";
// import { useDispatch, useSelector } from "react-redux";
// import { setCanvas, setDimensions, setMaskSprite, setLoading } from "../../Store/reducers/pixiCanvasSlice.js";
// import * as PIXI from "pixi.js";
// import PixiBackgrounds from "./pixiBackgrounds.jsx";
// import { initDevtools } from "@pixi/devtools";
// import DisplacementEffect from "./displacementEffect.jsx";
// import image5 from "../../assets/backgroundImages/white.png";
// import { setZoom } from "../../Store/reducers/fabriccontrolsSlice.js";
// import MainLoader from "../Loaders/MainLoader.jsx";

// // Base canvas size
// let BASE_WIDTH = 650;
// let BASE_HEIGHT = 500;

// const PixiCanvas = () => {
//     const canvasRef = useRef(null);
//     const parentRef = useRef(null);
//     const dispatch = useDispatch();
//     const appRef = useRef(null);
//     const { svgDetails } = useSelector((state) => state.svgDetails);
//     const pixiCanvas = useSelector((state) => state.canvas);
//     const loading = useSelector((state) => state.canvas.loading);
//     const maskSprite = useSelector((state) => state.canvas.maskSprite);
//     const selectedMockup = useSelector((state) => state.mockupCategories.selectedMockup) || [];
//     BASE_WIDTH=selectedMockup?.width
//     BASE_HEIGHT=selectedMockup?.height

//     const createPixiApp = () => {
//         const app = new PIXI.Application({
//             width: selectedMockup.width || BASE_WIDTH,
//             height: selectedMockup.height || BASE_HEIGHT,
//             backgroundColor: 0x00000000,
//             backgroundAlpha: 0,
//             antialias: true,
//             resolution: window.devicePixelRatio,
//             autoDensity: true,
//             powerPreference: "high-performance",
//             forceCanvas: false,
//         });
//         appRef.current = app;
//         if (canvasRef.current) canvasRef.current.appendChild(app.view);
//         initDevtools({ app });
//         return app;
//     };

//     const createMaskSprite = (app) => {
//         const maskTexture = PIXI.Texture.from(selectedMockup.mask_layer||image5);
//         const maskSprite = new PIXI.Sprite(maskTexture);
//         maskSprite.isMaskSprite = true;
//         maskSprite.anchor.set(0.5);
//         app.cameraContainer.addChild(maskSprite);
//         return maskSprite;
//     };

//     const adjustCanvasSize = (maskSprite) => {
//         const availableWidth = window.innerWidth - 100;
//         const availableHeight = window.innerHeight - 150;
//         const scaleX = availableWidth / BASE_WIDTH;
//         const scaleY = availableHeight / BASE_HEIGHT;
//         const baseScale = Math.min(scaleX, scaleY);
//         const newWidth = BASE_WIDTH * baseScale;
//         const newHeight = BASE_HEIGHT * baseScale;

//         // Resize the PIXI renderer
//         appRef.current.renderer.resize(newWidth, newHeight);
//         dispatch(setDimensions({ width: newWidth, height: newHeight }));
//         dispatch(setZoom(1)); // Reset zoom

//         // Resize and position mask sprite
//         maskSprite.width = newWidth;
//         maskSprite.height = newHeight;
//         maskSprite.x = newWidth / 2;
//         maskSprite.y = newHeight / 2;

//         // Center the camera container
//         appRef.current.cameraContainer.position.set(newWidth / 2, newHeight / 2);
//         appRef.current.cameraContainer.pivot.set(newWidth / 2, newHeight / 2);
//         appRef.current.cameraContainer.scale.set(1);
//     };

//     useEffect(() => {
//         if (appRef.current) return;

//         const app = createPixiApp();

//         // Create a camera container for zooming and panning
//         const cameraContainer = new PIXI.Container();
//         app.cameraContainer = cameraContainer;
//         app.stage.addChild(cameraContainer);

//         const maskSprite = createMaskSprite(app);

//         dispatch(setCanvas(app));
//         dispatch(setMaskSprite(maskSprite));
//         // Adjust canvas size initially
//         adjustCanvasSize(maskSprite);
//         const resizeListener = () => adjustCanvasSize(maskSprite);
//         window.addEventListener("resize", resizeListener);

//         return () => {
//             window.removeEventListener("resize", resizeListener);
//             app.destroy(true, { children: true });
//             appRef.current = null;
//         };
//     }, [selectedMockup]);

//     const isLoaded = (pixiCanvas && svgDetails && maskSprite) || !loading;

//     return (
//         <div className="flex-1 flex justify-center items-start relative" ref={parentRef}>
//             <div
//                 ref={canvasRef}
//                 className="justify-center items-center"
//                 style={{ display: isLoaded ? "block" : "none" }}
//             >
//                 <PixiBackgrounds  />
//                 <DisplacementEffect />
//             </div>
//             {!isLoaded && (
//                 <div className="absolute inset-0 flex justify-center items-center">
//                     <MainLoader />
//                 </div>
//             )}
//         </div>
//     );
// };

// export default PixiCanvas;
